import React from 'react';
import { Card, Col, Row } from 'antd';
import axios from 'axios';
import _ from 'lodash';

import { API_BASE_URL } from './GoogleMyBusiness/variables/Variables';

/**
 * Extracts width and height from an iframe HTML string returned by Facebook.
 * Falls back to sensible defaults per ad format if attributes are not found.
 */
function parseIframeDimensions(html) {
    const widthMatch  = html && html.match(/width="(\d+)"/);
    const heightMatch = html && html.match(/height="(\d+)"/);
    return {
        width:  widthMatch  ? parseInt(widthMatch[1],  10) : null,
        height: heightMatch ? parseInt(heightMatch[1], 10) : null,
    };
}

export default class FacebookAdPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            postStatus: props.post.state,
            approving: false,
            proofingContacts: [],
            comments: [],
            actions: [],
            submitting: false,
            commentValue: '',
            showCommentEditor: false
        };
    }

    componentDidMount() {
        if (this.props.post.body && this.props.post.body.proofItemType === 'SOCIAL') {
            const AD_ACCOUNT_ID = this.props.post.body.facebookAdId;
            const AD_FORMAT = this.props.post.body.ad_format || 'DESKTOP_FEED_STANDARD';

            /*
              Call the CLX backend proxy which fetches the Facebook Ad Preview
              iframe server-side (token is stored securely on the server and
              never exposed to the client).
            */
            axios
                .get(`${API_BASE_URL}facebook/ad-preview`, {
                    params: {
                        ad_id: AD_ACCOUNT_ID,
                        ad_format: AD_FORMAT,
                    }
                })
                .then(res => {
                    console.log('[FacebookAdPreview] raw response:', JSON.stringify(res.data));

                    // Support both direct pass-through { data: [...] } and
                    // wrapped { data: { data: [...] } } backend response shapes
                    const preview =
                        res.data && res.data.data && Array.isArray(res.data.data)
                            ? res.data.data[0]
                            : res.data;

                    console.log('[FacebookAdPreview] preview object:', preview);
                    console.log('[FacebookAdPreview] body:', preview && preview.body ? preview.body.slice(0, 200) : '(none)');

                    this.setState({ facebookAdPreview: preview, loading: false });
                })
                .catch(error => {
                    console.error('[FacebookAdPreview] META ERROR:', error.response ? error.response.data : error.message);
                    this.setState({ loading: false });
                });
        }
    }

    render() {
        const { post } = this.props;

        return (
            <div
                style={{
                    textAlign: 'left',
                    margin: 'auto',
                    maxWidth: 1400,
                    borderRadius: 2,
                    marginBottom: 16
                }}
                key={post.id}
                id={post.id}
            >
                <Row type="flex" justify="center" gutter={32}>
                    <Col>
                        <Card
                            style={{
                                backgroundColor:
                                    post.body && post.body.proofItemType === 'SOCIAL' ? null : 'rgb(240, 242, 245)',
                                boxShadow:
                                    post.body && post.body.proofItemType === 'SOCIAL'
                                        ? null
                                        : 'inset 0 2px 4px 0 rgba(0,0,0,.06)',
                                height: '100%'
                            }}
                            bodyStyle={{ paddingLeft: 8, paddingRight: 8 }}
                        >
                            <div
                                style={{
                                    borderRadius: 2,
                                    maxWidth:
                                        post.body &&
                                        (post.body.emailPreviewLink || post.body.proofItemType === 'SOCIAL')
                                            ? null
                                            : 500,
                                    margin: 'auto',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            >
                                <div
                                    style={{
                                        alignSelf: 'center',
                                        maxWidth: '100%',
                                        boxShadow:
                                            post.body && post.body.proofItemType === 'SOCIAL'
                                                ? null
                                                : '0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -1px rgba(0,0,0,.06)'
                                    }}
                                >
                                    {post.body && post.body.proofItemType === 'SOCIAL' && (
                                        <React.Fragment>
                                            {this.state.facebookAdPreview && this.state.facebookAdPreview.body ? (() => {
                                                const iframeHtml = this.state.facebookAdPreview.body
                                                    .replace(/scrolling="yes"/g, 'scrolling="no"');
                                                const { width, height } = parseIframeDimensions(iframeHtml);
                                                return (
                                                    <div
                                                        style={{
                                                            display:     'inline-block',
                                                            marginRight: 'auto',
                                                            marginLeft:  'auto',
                                                            width:       width  ? width  + 2 : 'auto',
                                                            height:      height ? height + 2 : 'auto',
                                                            overflow:    'hidden',
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: iframeHtml }}
                                                    />
                                                );
                                            })() : this.state.loading === false ? (
                                                <div style={{ padding: 16, color: '#999' }}>
                                                    Preview not available for this ad.
                                                </div>
                                            ) : (
                                                <div style={{ padding: 16, color: '#999' }}>
                                                    Loading preview…
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
